import { Divider, Grid, Typography } from '@material-ui/core';
import { format } from 'date-fns';
import React from 'react';

export const RequestWizardEnd: React.FC<{
    tenantName: string | undefined;
    reason: string;
    amount: number;
    notes: string;
    isDamageFlow: boolean;
    totalBillAmount: number;
    percentageOwing: number;
    dateReceived: Date;
    dateDue: Date;
}> = ({ tenantName, reason, amount, notes, isDamageFlow, totalBillAmount, percentageOwing, dateReceived, dateDue }) => {
    return (
        <>
            <Grid container spacing={4} style={{ marginTop: '1rem' }}>
                <Grid item xs={12} style={{ marginTop: '1rem' }}>
                    <Typography variant='h6'>
                        <big>
                            You are requesting ${amount.toFixed(2)} CAD from <br /> {tenantName}
                        </big>
                    </Typography>
                    <Typography variant='subtitle1'>
                        {tenantName} can either accept, decline, or suggest a different amount.
                    </Typography>
                </Grid>

                <Grid xs={12}>
                    <Divider />
                </Grid>

                <Grid item xs={12}>
                    <Typography variant='subtitle1'>
                        <b>Reason</b>
                    </Typography>
                    <Typography variant='subtitle1'>{reason}</Typography>
                </Grid>

                {!isDamageFlow && (
                    <>
                        <Grid xs={12}>
                            <Divider />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant='subtitle1'>
                                <b>Date Received</b>
                            </Typography>
                            <Typography variant='subtitle1'>
                                {format(dateReceived, 'PP')}
                            </Typography>
                        </Grid>
                    </>
                )}

                <Grid xs={12}>
                    <Divider />
                </Grid>

                <Grid item xs={12}>
                    <Typography variant='subtitle1'>
                        <b>Date Due</b>
                    </Typography>
                    <Typography variant='subtitle1'>{format(dateDue, 'PP')}</Typography>
                </Grid>

                {!isDamageFlow && (
                    <>
                        <Grid xs={12}>
                            <Divider />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant='subtitle1'>
                                <b>Total Bill Amount</b>
                            </Typography>
                            <Typography variant='subtitle1'>
                                ${totalBillAmount.toFixed(2)} CAD
                            </Typography>
                        </Grid>

                        <Grid xs={12}>
                            <Divider />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant='subtitle1'>
                                <b>Percentage Owing</b>
                            </Typography>
                            <Typography variant='subtitle1'>{percentageOwing}%</Typography>
                        </Grid>
                    </>
                )}

                <Grid xs={12}>
                    <Divider />
                </Grid>

                <Grid item xs={12}>
                    <Typography variant='subtitle1'>
                        <b>Amount Requested</b>
                    </Typography>
                    <Typography variant='subtitle1'>${amount.toFixed(2)} CAD</Typography>
                </Grid>

                <Grid xs={12}>
                    <Divider />
                </Grid>

                <Grid item xs={12}>
                    <Typography variant='subtitle1'>
                        <b>Notes</b>
                    </Typography>
                    <Typography variant='subtitle1'>{notes}</Typography>
                </Grid>
            </Grid>
        </>
    );
};
